/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module TooltipModule
 */

import { Component, Input } from '@angular/core';
import './avi-tooltip-content.component.less';

const componentName = 'avi-tooltip-content';
const caretClassNameHash = {
    TOP_POSITION: `${componentName}--top`,
    TOP_RIGHT_POSITION: `${componentName}--top-right`,
    TOP_LEFT_POSITION: `${componentName}--top-left`,
    BOTTOM_LEFT_POSITION: `${componentName}--bottom-left`,
    BOTTOM_RIGHT_POSITION: `${componentName}--bottom-right`,
    BOTTOM_POSITION: `${componentName}--bottom`,
};

/**
 * @description Component for tooltip content, displayed when an element is hovered/clicked.
 * @author alextsg
 */
@Component({
    selector: 'avi-tooltip-content',
    template: `
        <div class="avi-tooltip-content {{ caretClassName }}">
            <ng-content></ng-content>
        </div>
    `,
})
export class AviTooltipContentComponent {
    /**
     * TooltipPosition binding, used to determine the styling of the caret.
     * The value is passed in by avi-tooltip in nsx-alb-ui-components, but importing it as a type is causing issues.
     * Setting it as any to avoid the type error.
     */
    @Input('tooltipPosition')
    public set tooltipPosition(position: any) {
        this.caretClassName = caretClassNameHash[position];
    }

    /**
     * Class applied to add styling for a caret.
     */
    public caretClassName = caretClassNameHash.TOP_RIGHT_POSITION;
}
